import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@mentimeter/ragnar-visuals';
import { Box } from '@mentimeter/ragnar-ui/box';
import { IconButton } from '@mentimeter/ragnar-ui/icon-button';

interface DetailViewNavigationProps {
  onNavigate: (direction: 'next' | 'previous') => void;
  canNavigateNext: boolean;
  canNavigatePrevious: boolean;
}

export const DetailViewNavigation = ({
  onNavigate,
  canNavigateNext,
  canNavigatePrevious,
}: DetailViewNavigationProps) => {
  return (
    <Box
      flexDirection="row"
      flex="1"
      justifyContent="flex-end"
      alignItems="flex-end"
      height="60%"
      mr="space6"
    >
      <IconButton
        data-testid="group-detail-view-previous-button"
        onClick={() => onNavigate('previous')}
        disabled={!canNavigatePrevious}
        variant="outline"
        size="large"
        style={{ boxShadow: 'none', backgroundColor: 'transparent' }}
      >
        <ChevronLeftIcon
          size={3}
          color={canNavigatePrevious ? 'text' : 'textWeaker'}
        />
      </IconButton>
      <IconButton
        disabled={!canNavigateNext}
        onClick={() => onNavigate('next')}
        variant="outline"
        size="large"
        style={{ boxShadow: 'none', backgroundColor: 'transparent' }}
      >
        <ChevronRightIcon
          color={canNavigateNext ? 'text' : 'textWeaker'}
          size={3}
        />
      </IconButton>
    </Box>
  );
};
